import { render, staticRenderFns } from "./braceletInfo.vue?vue&type=template&id=415827c2&scoped=true&"
import script from "./braceletInfo.vue?vue&type=script&lang=js&"
export * from "./braceletInfo.vue?vue&type=script&lang=js&"
import style0 from "./braceletInfo.vue?vue&type=style&index=0&id=415827c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415827c2",
  null
  
)

export default component.exports